import { render, staticRenderFns } from "./ArrayFieldForm.vue?vue&type=template&id=120b8cc6&scoped=true"
import script from "./ArrayFieldForm.vue?vue&type=script&lang=js"
export * from "./ArrayFieldForm.vue?vue&type=script&lang=js"
import style0 from "./ArrayFieldForm.vue?vue&type=style&index=0&id=120b8cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120b8cc6",
  null
  
)

export default component.exports